import "./TalkToAnExpert.module.css";
import Header from "@/reusable_sections/Header";
import ConsultWithARecoverySpecialist from "./sections/ConsultWithARecoverySpecialist";
import CommonRecoveryQuestions from "./sections/CommonRecoveryQuestions";
import Footer from "@/reusable_sections/Footer";
export default function TalkToAnExpertPage() {
  return <div>
      <Header />
      <ConsultWithARecoverySpecialist />
      <CommonRecoveryQuestions />
      <Footer />
    </div>;
}